// extracted by mini-css-extract-plugin
module.exports = {"MultiButton":"MultiButton__3YEyd","MultiButton--inline":"MultiButton--inline__2cni8","MultiButton__hiddenElement":"MultiButton__hiddenElement__38KBP"};